// extracted by mini-css-extract-plugin
export default {"wrapper":"ProjectMenu_wrapper_rhdlM","divider":"ProjectMenu_divider_Go13U"};